<template>
    <div class="container-fluid">
        <Breadcrumb title="SpamTrap Email List" button-url="spamEmailCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="form-inline">
                            <div class="form-group mb-2">
                                <button type="button" class="btn btn-success btn-rounded"
                                        @click="addSpamEmailsList"><i
                                        class="fas fa-upload"></i>
                                    Upload file with emails
                                </button>
                            </div>
                            <div class="form-group mx-sm-3 mb-2" v-if="totalItems > 0">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group p-t-10">
                            <div class="progress" v-for="(uploadEmail,index) in uploadEmails" :key="index">
                                <div class="progress-bar bg-info"
                                     v-bind:style="{width: uploadEmail.completion}" role="progressbar"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                    {{uploadEmail.completion}}
                                </div>
                            </div>
                        </div>
                        <div class="input-group form-group">
                            <input v-model="spamEmailSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search email">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div v-if="spamEmailsList.length === 0">SpamTrap emails list is empty!</div>
                        <div v-else>
                            <div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Email</th>
                                            <th>Info</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(email, index) in spamEmailsList" :key="index">
                                            <td class="align-middle">{{email.id}}</td>
                                            <td class="align-middle">{{email.email.email}}</td>
                                            <td class="align-middle">{{email.info}}</td>
                                            <td>
                                                <button type="button" class="btn btn-danger btn-sm m-r-15"
                                                        @click="deleteSpamEmail(email.email.id)">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import SpamEmailService from '../services/SpamEmailService';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import { mapGetters } from 'vuex';

    export default {
        name: 'SpamEmails',
        components: {
            Breadcrumb,
            Preloader
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                spamEmailSearch: null,
                spamEmailsList: [],
                spamEmailFile: '',
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                jobs: [],
                uploadEmails: []
            }
        },
        mounted() {
            this.getItems(this.page = 1);
            this.uploadSpamEmailListProgress();
        },
        methods: {
            search: function () {
                this.getItems(this.page = 1);
            },
            uploadSpamEmailListProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadSpamEmailProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadSpamEmailProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadSpamEmailProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadSpamEmailProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data) {
                        let index = this.uploadEmails.findIndex(obj => obj.uuid === data.uuid);
                        if (index < 0) {
                            this.uploadEmails.push({
                                'uuid': data.uuid,
                                'completion': parseInt(data.completion) + '%'
                            });
                        } else {
                            this.uploadEmails[index].completion = parseInt(data.completion) + '%';
                            if (100 === parseInt(data.completion)) {
                                this.$snotify.success('File ' + data.filename + ' is processed!');
                                this.uploadEmails.splice(index, 1);
                                this.getItems(this.page);
                            }
                        }
                    }
                }
            },
            addSpamEmailsList() {
                Swal({
                    title: 'Add SpamTrap Email List',
                    text: '',
                    html: '<p>Comma separated CSV without header.</br>Line format: "email,info"</p><input type="file" id="spam_emails" accept="text/csv" />',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let emails = document.getElementById('spam_emails').files[0];
                        let formData = new FormData();
                        formData.append('spam_emails', emails);
                        return SpamEmailService.addSpamEmails(formData).then(response => {
                            if (response.status === 200) {
                                this.$snotify.warning('File processing started!');
                            }
                            if (response.data.error) {
                                Swal.showValidationMessage(
                                    `${response.data.error.spam_emails}`
                                );
                                return false;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `We will notify you, when moderation process will be done.`,
                            'success'
                        )
                    }
                })
            },
            deleteSpamEmail(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SpamEmailService.deleteSpamEmail(id).then((response) => {
                            if (response.status === 204) {
                                let index = this.spamEmailsList.findIndex(obj => obj.email.id === id);
                                this.spamEmailsList.splice(index, 1);
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Spam Email has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            getItems: function (pageNum) {
                this.loading = true;
                SpamEmailService.getSpamEmailsList(pageNum, this.perPage, this.spamEmailSearch).then(response => {
                    this.spamEmailsList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    });
                    this.loading = false;
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    }
</script>

<style scoped>

</style>
